import $ from "jquery";
window.$ = window.jQuery = $;

import "slick-carousel";
let Rellax = require('rellax')

$(function () {

  $('.cat-wrap').hover(function () {
    $('.cat-wrap').removeClass("active");
    $(this).addClass("active");
  });

  $('textarea').on("input", function () {
    var maxlength = 300;
    var currentLength = $(this).val().length;

    $('body').on('keyup paste', 'textarea', function () {
      $(this).val($(this).val().substring(0, maxlength));
      var tlength = $(this).val().length;
      var remain = maxlength - parseInt(tlength);
      $('#remain').text(remain);
    });

    if (currentLength >= maxlength) {
      console.log("You have reached the maximum number of characters.");

    } else {
      console.log(maxlength - currentLength + " chars left");
    }
  });


  let rellax = new Rellax('.rellax', {
    wrapper: '.advanced-columns',
    relativeToWrapper: true,
    transform: 'rotate(45deg)',
  });



  $(".product-carousel .products").slick({
    arrows: true,
    prevArrow: $('.left-arrow2'),
    nextArrow: $('.right-arrow2'),
    dots: false,
    infinite: true,
    speed: 750,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".testimonials-slider").slick({
    arrows: true,
    prevArrow: $('.left-arrow'),
    nextArrow: $('.right-arrow'),
    dots: true,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  });

  var hamburger = document.querySelector(".menu-toggle");
  var menuClose = document.querySelector(".menu-close");
  hamburger.addEventListener("click", function () {
    hamburger.classList.toggle("is-active");
    $("body").toggleClass("menu-is-open");
  });
  menuClose.addEventListener("click", function () {
    $("body").removeClass("menu-is-open");
  });

  var hasChildren = document.querySelector(".menu-item-has-children a");
  hasChildren.addEventListener("click", function (e) {
    e.preventDefault();
    $(".menu").addClass("level-2");
    $(this).next(".sub-menu").addClass("active");
  });

  var menuButton = document.querySelector(".menu-back");
  menuButton.addEventListener("click", function () {
    $(".menu").removeClass("level-2");
    $(".sub-menu").removeClass("active");
  });

  $("body:not(.woocommerce-cart) .cart-icon").on({
    mouseenter: function () {
      $(this).addClass("hover");
    },
    mouseleave: function () {
      $(".cart-icon").removeClass("hover");

      // // $(this).removeClass("hover");
      // if ($('.widget_shopping_cart_content').is(':hover')) {
      //   // do NOTHING ;)
      // } else {
      //   $(".cart-icon").removeClass("hover");
      // }
    }
  });

  var search = document.querySelector(".search-open");
  search.addEventListener("click", function () {
    $("body").toggleClass("search-is-open");
  });
  var searchClose = document.querySelector(".search-close");

  searchClose.addEventListener("click", function () {
    $("body").removeClass("search-is-open");
  });

  headerScroll();
  //wc-block-grid__products
  //
  // Accordion
  //
  var allPanels = $(".accordion-items > li > div").hide();

  $(".accordion-items > li > a").click(function () {
    if (!$(this).hasClass("opened")) {
      $(".accordion-items > li > a").removeClass("opened");
      $(this).addClass("opened");
      allPanels.slideUp();
      $(this).next().slideDown();
      $(".accordion-items > li > a .arrow").removeClass("rotated");
      $(this).find(".arrow").toggleClass("rotated");
    } else {
      $(this).removeClass("opened");
      $(this).next().slideUp();
      $(".accordion-items > li > a .arrow").removeClass("rotated");
    }
    return false;
  });
});

jQuery(window).scroll(function ($) {
  headerScroll();
});

jQuery(window).load(function ($) {});

jQuery(window).resize(function ($) {});

function sizetorow(divheight, target, adjustment) {
  var $ = jQuery;
  if ($(window).width() > 800) {
    var maxHeight = 0;

    $(target).css("min-height", maxHeight);
    var maxHeight = $(divheight).height() - adjustment;
    console.log(maxHeight);
    //$(target).each(function(){
    //
    //})
    setTimeout(function () {
      $(target).css("min-height", maxHeight);
    }, 600);
  }
}

function makesquare(target) {
  var $ = jQuery;
  var width = $(target).width();
  $(target).height(width);
}

function headerScroll() {
  var $ = jQuery;

  scroll = $(window).scrollTop();

  if (scroll >= 30) {
    $("body").addClass("is-scrolled");
  } else {
    $("body").removeClass("is-scrolled");
  }
}


// WEBPACK FOOTER //
// ./main.js